import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ArrowRight } from 'lucide-react';
import './CaseStudies.css';

const cases = [
  {
    category: 'Cloud Infrastructure & DevOps',
    title: 'Cutting AWS Cloud Hosting Costs by 70% for FinTech Leader',
    desc: 'Restructured a high-traffic wealthtech platform from monolithic EC2 instances to Amazon EKS Spot clusters, automated S3 log lifecycle rules, and optimized RDS multi-AZ databases.',
    metric: '70% Savings',
    metricLabel: 'Monthly AWS Hosting Reduction'
  },
  {
    category: 'Custom Steel ERP & Manufacturing',
    title: 'Weighbridge & Yield Automation for Ghaziabad Steel Rolling Mill',
    desc: 'Eliminated weighbridge data leakage, integrated automated heat/billet batch logs, and linked digital GST e-way bills directly to Tally accounting.',
    metric: '₹1.2 Crore/Yr',
    metricLabel: 'Recovered Operations Leakage'
  },
  {
    category: 'Healthcare & ABDM Systems',
    title: 'Mediway HMS Deployment across 120-Bed Multi-Specialty Hospital',
    desc: 'Implemented end-to-end OPD/IPD queue management, ABHA card integration, automated pharmacy stock reordering, and NABH incident audit reporting.',
    metric: '45 Mins Saved',
    metricLabel: 'Average Patient Discharge Time'
  }
];

export default function CaseStudies() {
  const whatsappUrl = "https://wa.me/918287999236?text=Hi%20Wayug!%20I%20read%20your%20Case%20Studies%20and%20would%20like%20to%20discuss%20a%20similar%20project.";

  return (
    <section className="cs-section">
      <div className="container">
        
        {/* Hero */}
        <motion.div 
          className="cs-hero"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="cs-badge">
            <FileText size={16} /> Client Success Stories
          </div>
          <h1 className="cs-title">
            Enterprise Impact &amp; <span className="gradient-text">Case Studies</span>
          </h1>
          <p className="cs-subtitle">
            Explore how Wayug Infotech helps enterprises, manufacturers, and hospital networks cut hosting overhead, digitize floor operations, and achieve strict compliance.
          </p>
        </motion.div>

        {/* Case Studies Grid */}
        <div className="cs-grid">
          {cases.map((item, idx) => (
            <motion.div 
              key={item.title}
              className="cs-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <div>
                <span className="cs-tag">{item.category}</span>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
              <div>
                <div className="cs-metric">{item.metric}</div>
                <div className="cs-metric-label">{item.metricLabel}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center" style={{ marginTop: '40px' }}>
          <a 
            href={whatsappUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn btn-primary"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
          >
            Discuss Your Enterprise Project <ArrowRight size={16} />
          </a>
        </div>

      </div>
    </section>
  );
}
